// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggleImage {
  border-radius: 50%;
  margin-top: 70px;
  height: 60px;
  text-align: center;
  margin-left: 76px;
}

.toggleH5 {
  color: #f2f2f2;
  font-size: 14px;
  margin-top: 8px;
  margin-bottom: 24px;
  text-align: center;
}

.toggleQue {
  font-size: 16px;
  color: #aeb2b7;
  cursor: pointer;
  background-color: black;
  border: none;
  display: block;
  padding: 15px 105px 15px 10px;
}
.toggleQue:active,
.toggleQue:hover,
.toggleQue:focus {
  background-color: #68dff0;
  color: white;
}

.toggleBr {
  font-size: 5px;
}

.toggleQSet {
  font-size: 16px;
  color: #aeb2b7;
  cursor: pointer;
  background-color: black;
  border: none;
  display: block;
  padding: 15px 141px 15px 10px;
}
.toggleQSet:active,
.toggleQSet:hover,
.toggleQSet:focus {
  background-color: #68dff0;
  color: white;
}

.togglebar .bookIcon {
  font-size: 18px;
  margin-bottom: -4px;
}

.toggleLink {
  font-size: 14px;
  padding: 6px 0;
  line-height: 35px;
  height: 35px;
  color: #aeb2b7;
  text-decoration: none;
  font-family: "Ruda", sans-serif;
  margin-left: 44px;
}
.toggleLink:hover {
  color: white;
}
.toggleLink:active,
.toggleLink:focus {
  color: #68dff0;
}

.toggleLink1 {
  font-size: 14px;
  padding: 6px 0;
  line-height: 35px;
  height: 35px;
  color: #68dff0;
  text-decoration: none;
  font-family: "Ruda", sans-serif;
  margin-left: 44px;
}

/* .react-slidedown  */
.my-dropdown-slidedown {
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
}

.toggleReport {
  font-size: 16px;
  color: #aeb2b7;
  cursor: pointer;
  background-color: black;
  border: none;
  display: block;
  padding: 15px 120px 15px 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/SubComponents/Togglebar/togglebar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,6BAA6B;AAC/B;AACA;;;EAGE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,6BAA6B;AAC/B;AACA;;;EAGE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,6BAA6B;AAC/B","sourcesContent":[".toggleImage {\n  border-radius: 50%;\n  margin-top: 70px;\n  height: 60px;\n  text-align: center;\n  margin-left: 76px;\n}\n\n.toggleH5 {\n  color: #f2f2f2;\n  font-size: 14px;\n  margin-top: 8px;\n  margin-bottom: 24px;\n  text-align: center;\n}\n\n.toggleQue {\n  font-size: 16px;\n  color: #aeb2b7;\n  cursor: pointer;\n  background-color: black;\n  border: none;\n  display: block;\n  padding: 15px 105px 15px 10px;\n}\n.toggleQue:active,\n.toggleQue:hover,\n.toggleQue:focus {\n  background-color: #68dff0;\n  color: white;\n}\n\n.toggleBr {\n  font-size: 5px;\n}\n\n.toggleQSet {\n  font-size: 16px;\n  color: #aeb2b7;\n  cursor: pointer;\n  background-color: black;\n  border: none;\n  display: block;\n  padding: 15px 141px 15px 10px;\n}\n.toggleQSet:active,\n.toggleQSet:hover,\n.toggleQSet:focus {\n  background-color: #68dff0;\n  color: white;\n}\n\n.togglebar .bookIcon {\n  font-size: 18px;\n  margin-bottom: -4px;\n}\n\n.toggleLink {\n  font-size: 14px;\n  padding: 6px 0;\n  line-height: 35px;\n  height: 35px;\n  color: #aeb2b7;\n  text-decoration: none;\n  font-family: \"Ruda\", sans-serif;\n  margin-left: 44px;\n}\n.toggleLink:hover {\n  color: white;\n}\n.toggleLink:active,\n.toggleLink:focus {\n  color: #68dff0;\n}\n\n.toggleLink1 {\n  font-size: 14px;\n  padding: 6px 0;\n  line-height: 35px;\n  height: 35px;\n  color: #68dff0;\n  text-decoration: none;\n  font-family: \"Ruda\", sans-serif;\n  margin-left: 44px;\n}\n\n/* .react-slidedown  */\n.my-dropdown-slidedown {\n  transition-duration: 0.3s;\n  transition-timing-function: ease-in-out;\n}\n\n.toggleReport {\n  font-size: 16px;\n  color: #aeb2b7;\n  cursor: pointer;\n  background-color: black;\n  border: none;\n  display: block;\n  padding: 15px 120px 15px 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
